import React, { useReducer, useMemo, useState, useEffect } from "react";
// import NurtureCampaignContact from "./NurtureCampaignContact/NurtureCampaignContact";
import NurtureCampaignInitComp from "./NurtureCampaignInitComp/NurtureCampaignInitComp";
import NurtureCampaignContactMinimal from "./NurtureCampaignContact/NurtureCampaignContactMinimal";
import "./NurtureCampaignContact/NurtureCampaignContactSearch.css";
import { changeCampaignDate, previewCampaignDetails } from "../../../../../services/iqApiV2";
import { useUser } from "../../../../../context/UserContext";
import { findContactCardData } from "../../../../../store/features/sagas/opportunities/contactCardSaga";
import NurtureCampaignEmailReachOutV2 from "./NurtureCampaignEmailReachOut/NurtureCampaignEmailReachOutV2"; 
import { parseContact, STEP_IDS } from "../../../../../utilities/uiUtils";
import { formatDateToYMD } from "../../../../../utilities/dateUtils";
import DynamicAlertDialog from "../../../genericComponents/uiElements/DynamicAlertDialog";
import UpdateNurtureDate from "./UpdateNurtureDate";
import DynamicStepper from "../../../genericComponents/uiElements/DynamicStepper";
import { useDispatch } from "react-redux";
import { FetchAutoNurtureRequest } from "../../../../../store/features/actions/autoNurture/autoNurtureActions";


const initialStepState = {
  [STEP_IDS.CAMPAIGN_INIT]: false,
  [STEP_IDS.CONTACT]: false,
  [STEP_IDS.EMAIL_REACHOUT]: false,
  [STEP_IDS.FINAL_REVIEW]: false,
};
const STEP_ORDER = [
  STEP_IDS.CAMPAIGN_INIT,
  STEP_IDS.CONTACT,
  STEP_IDS.EMAIL_REACHOUT,
  STEP_IDS.FINAL_REVIEW,
];

function getLastCompletedIndex(completed) {
  for (let i = STEP_ORDER.length - 1; i >= 0; i--) {
    if (completed[STEP_ORDER[i]]) {
      return i;
    }
  }
  return 0;
}
function stepReducer(state, action) {
  switch (action.type) {
    case "MARK_COMPLETED":
      return { ...state, [action.payload]: true };
    case "RESET_STEP":
      return { ...state, [action.payload]: false };
    default:
      return state;
  }
}


const NurtureCardHeader = ({ setOpenGenerateNurture, campaignID = null }) => {
 
  const {user} = useUser();
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [completedSteps, dispatch] = useReducer(stepReducer, initialStepState);
  const [currentCampDetails, setCurrentCampDetails] = useState({});
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [domain, setDomain] = useState("");
  const [emails, setEmails] = useState([]);
  const [searchHist, setSearchHist] = useState({});
  const [compInitiating, setCompInitiating] = useState(false);
  const [newFlow, setNewFlow] = useState(false);
  const [selectedCompanies, setSelectedCompanies] = useState(
    currentCampDetails?.account
  );
  const [productsList, setProducts] = useState([]);

 const reducDispatch = useDispatch();

 
 useEffect(() => {
  console.log("📌 Mounted: NurtureCardHeader");

  return () => {
    console.log("📤 Unmounting: Dispatching cleanup API");
    reducDispatch(
      FetchAutoNurtureRequest({ clientName: null, accountName: null, userId: user?.id })
    );
  };
}, []);

  

  const prefilDataPerOpp = async (opp) => {
    setNewFlow(true);
    const productsWithDesc = (opp?.mapped_products || []).map((item) => {
      const matched = productsList?.find((p) => p?.product_name === item);
      return {
        name: item,
        description: matched?.product_description || "",
      };
    });

    setCurrentCampDetails((prev) => {
      return {
        ...prev,
        campaignName: opp?.opportunity_name,
        campaignContext: opp?.opportunity_description,
        startDate: formatDateToYMD(new Date()),
        products: productsWithDesc,
        daysFrequency: 3,
        account: selectedCompanies,
        opportunityId: opp?.opportunity_id,
      };
    });
    const resp = await findContactCardData(opp?.opportunity_id, user?.id);

    setSelectedContacts(resp || []);
  };
  useEffect(() => {
    const fetchCampaignData = async () => {
      try {
        setCompInitiating(true);
        const response = await previewCampaignDetails(campaignID);
        const campaignSetupHist = response?.campaign?.[0];
        const contactHist = response?.contacts?.[0];
        const templatehist = response?.templates?.[0];
        const finalTick = campaignSetupHist?.active_status
        const lastStep = campaignSetupHist?.search_list?.[0]?.currentStepId;
        setCurrentCampDetails(prev=>({
          ...prev,
          campActive:finalTick,
          lastStep:lastStep
        }))

        if ([STEP_IDS.CAMPAIGN_INIT, STEP_IDS.CONTACT].includes(lastStep)) {
          dispatch({ type: "MARK_COMPLETED", payload: STEP_IDS.CAMPAIGN_INIT });
          setNewFlow(true);
          setCurrentStepIndex(0);

          if (lastStep === STEP_IDS.CONTACT) {
            dispatch({ type: "MARK_COMPLETED", payload: STEP_IDS.CONTACT });
            setCurrentStepIndex(1);
          }
        }

        if (finalTick === 1) {
          dispatch({
            type: "MARK_COMPLETED",
            payload: STEP_IDS.EMAIL_REACHOUT,
          });
          setCurrentStepIndex(2);
        }

        const processedContactHist = contactHist?.map(parseContact);
        setSelectedContacts(processedContactHist);

        setSearchHist(campaignSetupHist?.search_list?.[0]);
        setEmails(templatehist);
        setCurrentCampDetails((prev) => {
          return {
            ...prev,
            campaignName: campaignSetupHist?.title,
            emailGenerationCount:campaignSetupHist?.email_generation_count,
            campaignContext: campaignSetupHist?.context,
            startDate: campaignSetupHist?.start_date,
            account: campaignSetupHist?.account,
            products: campaignSetupHist?.products,
            campaignId: campaignID,
            daysFrequency: 3,
          };
        });
        setDomain(campaignSetupHist?.search_list?.[0]?.domain);
        setCurrentStepIndex(getLastCompletedIndex({
          ...initialStepState,
          ...completedSteps,
          [STEP_IDS.CAMPAIGN_INIT]: !!response?.campaign?.[0],
          [STEP_IDS.CONTACT]: !!response?.contacts?.[0]?.length,
          [STEP_IDS.EMAIL_REACHOUT]: !!response?.templates?.[0]?.length,
        }));
      //  }
        setCompInitiating(false);
      } catch (error) {
        setCompInitiating(false);
        console.error("Error fetching campaign details:", error);
      }
    };

    if (campaignID) fetchCampaignData();
  }, [campaignID]);

  const stepsConfig = [
    {
      id: STEP_IDS.CAMPAIGN_INIT,
      title: "Setup",
      component: (
        <>
        <NurtureCampaignInitComp
          stepDispatch={dispatch}
          stepId={STEP_IDS.CAMPAIGN_INIT}
          setCurrentCampDetails={setCurrentCampDetails}
          setCurrentStepIndex={setCurrentStepIndex}
          currentCampDetails={currentCampDetails}
          domain={domain}
          setDomain={setDomain}
          newFlow={newFlow} setNewFlow={setNewFlow}
          prefilDataPerOpp={prefilDataPerOpp}
          selectedCompanies={selectedCompanies} setSelectedCompanies={setSelectedCompanies}
          selectedContacts={selectedContacts}
          productsList={productsList} setProducts={setProducts}
        />
        </>
      ),
    },
    {
      id: STEP_IDS.CONTACT,
      title: "Contact",
      component: (
        <NurtureCampaignContactMinimal
          stepDispatch={dispatch}
          stepId={STEP_IDS.CONTACT}
          currentCampDetails={currentCampDetails}
          setCurrentStepIndex={setCurrentStepIndex}
          searchHist={searchHist}
          setSearchHist={setSearchHist}
          selectedContacts={selectedContacts}
          setSelectedContacts={setSelectedContacts}
          domain={domain}
        />
      ),
    },
    {
      id: STEP_IDS.EMAIL_REACHOUT,
      title: "Email Reachout",
      component: (
        <NurtureCampaignEmailReachOutV2
          stepDispatch={dispatch}
          stepId={STEP_IDS.EMAIL_REACHOUT}
          currentCampDetails={currentCampDetails}
          setCurrentStepIndex={setCurrentStepIndex}
          emails={emails}
          setEmails={setEmails}
          skipReview={true}
          sideCardCloseFunc={setOpenGenerateNurture}
        />
      ),
    },
  ];

  const campaignStartDate = currentCampDetails?.startDate
    ? formatDateToYMD(new Date(currentCampDetails?.startDate))
    : formatDateToYMD(new Date());
  const today = formatDateToYMD(new Date());
  
  return (
    <>


       <DynamicStepper
      stepsConfig={stepsConfig}
      completedSteps={completedSteps}
      currentStepIndex={currentStepIndex}
      setCurrentStepIndex={setCurrentStepIndex}
      compInitiating={compInitiating}
      campaignStartDate={campaignStartDate}
      today={today}
      campActive={currentCampDetails?.campActive}
    />

      {campaignStartDate < today && !currentCampDetails?.campActive && (
        <DynamicAlertDialog
          title="Date Alert"
          message={
            <>
              <UpdateNurtureDate
                handleDateUpdatePostActions={async (newDate) => {
                  if (currentCampDetails?.campaignId) {
                    try {
                      await changeCampaignDate(
                        newDate,
                        currentCampDetails?.campaignId,
                        user?.id
                      );
                    } catch (error) {
                      console.error("changeCampaignDate error", error);
                    }finally{
                    setCurrentCampDetails((prev) => ({
                      ...prev,
                      startDate: formatDateToYMD(new Date(newDate)),
                    }));
                    }


                  }
                }}
              />
            </>
          }
          type="info"
          autoShow={true}
        />
      )}
    </>
  );
};

export default NurtureCardHeader;
